import React, { useState, useEffect } from "react";
import "./PopupQuestion.css";
import question from "../imagesHome/help.png";
import conti from "../imagesHome/conti.png";
import coinImg from "../header/images/coin.png";

const PopupQuestion = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const openPopup = () => {
    if (isVisible && isOpen) return;
    setIsVisible(true);
    requestAnimationFrame(() => setIsOpen(true));
  };

  const closePopup = () => {
    if (!isVisible) return;
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isVisible) return;

    const closeTimer = setTimeout(() => {
      if (!isOpen) {
        setIsVisible(false);
      }
    }, 280);

    return () => clearTimeout(closeTimer);
  }, [isVisible, isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("quiz-active");
      document.documentElement.classList.add("quiz-active");
    } else {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    }

    return () => {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isVisible) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isVisible]);

  return (
    <div className="popup-question-container">
      <button
        type="button"
        className="oriented-question-track"
        onClick={isOpen ? closePopup : openPopup}
        aria-label="Deschide ajutor"
      >
        <img src={question} className="question-popup-icon" alt="Ajutor" />
      </button>

      {isVisible && (
        <>
          <div className={`popup-question-overlay ${isOpen ? "open" : ""}`} onClick={closePopup} />
          <div
            className={`popup-question ${isOpen ? "open" : ""}`}
            role="dialog"
            aria-modal="true"
            aria-label="Ajutor pentru lecție"
          >
            <button className="popup-question-close" onClick={closePopup}>
              ×
            </button>
            <div className="popup-question-content">
              <div className="popup-question-mascot">
                <img src={conti} className="popup-question-conti" alt="Conti" />
                <div className="popup-question-bubble">
                  <p>Ai rămas blocat? Te pot ajuta!</p>
                </div>
              </div>
              <div className="popup-question-btns">
                <button className="popup-question-btn popup-question-btn--hint">
                  <span className="popup-question-btn-label">Vezi explicația</span>
                  <span className="popup-question-btn-price">
                    <img src={coinImg} className="popup-coin-icon" alt="coins" /> 20
                  </span>
                </button>
                <button className="popup-question-btn popup-question-btn--answer">
                  <span className="popup-question-btn-label">Vezi răspunsul</span>
                  <span className="popup-question-btn-price">
                    <img src={coinImg} className="popup-coin-icon" alt="coins" /> 30
                  </span>
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PopupQuestion;
